// styled/PageTitleStyles.ts
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

// Using the PREFIX in the naming convention
export const FieldProTitle = styled(Typography)({
  textTransform: "uppercase",
  // You can add more styles here as needed
});
